var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-bar"},[_c('div',{staticClass:"title-container p-3"},[_c('div',{staticClass:"texts"},[_c('h4',{staticClass:"text name",style:(_vm.textOverflow)},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"text amount"},[_vm._v(_vm._s(_vm.content))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }